export class Validador {
    ID: number;
    nombreCompleto: string;
    email: string;
    ciudad: string;
    tipologiaID: string;
    visitador: boolean;
    activo: boolean;
    userID: number;
}
